export default {
  'paymentHistory.time.last_three_months': 'Last Three Months',
  'paymentHistory.time.last_six_months': 'Last Six Months',
  'paymentHistory.time.last_one_year': 'Last One Year',
  'paymentHistory.status.completed': 'Completed',
  'paymentHistory.status.canceled': 'Canceled',
  'paymentHistory.status.partial_canceled': 'Partially Canceled',
  'paymentHistory.title': 'Transaction History',
  'paymentHistory.detail': 'Transaction Details',
  'paymentHistory.update_time': 'Time',
  'paymentHistory.total_amount': 'Total Amount',
  'paymentHistory.store': 'Store',
  'paymentHistory.status': 'Status',
  'paymentHistory.level_progress_text.amounts':
    'Spend another <span style="font-weight: 600;color: #05B34D;">{amount}</span> to qualify',
  'paymentHistory.level_progress_text.counts':
    'Spend <span style="font-weight: 600;color: #05B34D;">{count}</span> more times over <span style="font-weight: 600;color: #05B34D;">{amount}</span> to qualify',
  'paymentHistory.level_progress_text.or': 'or',
  'paymentHistory.period_amount': 'Total Spend During Validity Period',
  'paymentHistory.member_total_amount': 'Total Member Spend',
  'paymentHistory.dollar': 'USD',
  'paymentHistory.zero_dollar': '0 USD',
  'paymentHistory.trade_time': 'Transaction Time',
  'paymentHistory.empty': 'No Data',
  'paymentHistory.name': 'Name',
  'paymentHistory.quantity': 'Quantity',
  'paymentHistory.price': 'Unit Price',
  'paymentHistory.amount': 'Amount Spent',
  'paymentHistory.cancel_date': 'Cancellation Time',
} as Record<string, string>;
